import { FC } from 'react';
import {
    NonAuthorizedContentWithImageLayout,
    RightColumnImage,
} from '@/bo-kit/components/NonAuthorizedContentWithImageLayout';
import { ResetPasswordForm } from '@/bo-kit/components/ResetPasswordPage/components/ResetPassword/ResetPasswordForm';
import birdImg from '@/bo-kit/components/ResetPasswordPage/components/ResetPassword/images/birdImg.svg';
import { useTranslation } from '@/ui-kit/hooks/useTranslation';

const ResetPasswordPageResponsive: FC<{ implementation?: 'js' | 'css' }> = ({ implementation }) => {
    const { t } = useTranslation('bo-kit__common');
    return (
        <NonAuthorizedContentWithImageLayout
            title={t('Reset password')}
            implementation={implementation}
            content={<ResetPasswordForm />}
            image={<RightColumnImage src={birdImg} />}
        />
    );
};

// ADHOC: support lazy import
export default ResetPasswordPageResponsive;
